import { useFeatureFlag } from 'entities/helpers/use-feature-flag';
import InteractionDetailController from './interaction-detail-controller';

const InteractionDetailControllerWrapper = (props) => {
  const { flagEnabled: enableInteractionSolicitorType } = useFeatureFlag('enableInteractionSolicitorType');
  const { flagEnabled: interactionDescriptionRichTextEditor } = useFeatureFlag('interactionDescriptionRichTextEditor');

  const flags = {
    enableInteractionSolicitorType,
    interactionDescriptionRichTextEditor,
  };

  return <InteractionDetailController {...props} flags={flags} />;
};

export default InteractionDetailControllerWrapper;
